import { render } from "./localizedText.vue?vue&type=template&id=5d6b2174&scoped=true&ts=true"
import script from "./localizedText.vue?vue&type=script&lang=ts"
export * from "./localizedText.vue?vue&type=script&lang=ts"

import "./localizedText.vue?vue&type=style&index=0&id=5d6b2174&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6b2174"]])

export default __exports__